import React from 'react';

const Video = (props) => {
    return (
        <video controls width="100%" poster={props.previewImage}>
            <source src={props.videoFile} type="video/mp4" />
            {/* <source src="/path-to-your-video.webm" type="video/webm" /> */}
            Sorry, your browser doesn't support embedded videos.
        </video>
    );
};

export default Video;
